var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js
// module id = 41
// module chunks = 0